import React from 'react'
import Breadcrumbs from '../../components/Breadcrumbs';

function WaterWell() {
    // const page = "waterwell";
    const page = "industry";
  return (
    <div>
        <section className={`hero ${page}`}>
            <h1>Water Well</h1>
        </section>

        <Breadcrumbs
            items={[
                { label: "Home", to: "/" },
                { label: "Solutions", to: "/solutions" },
                { label: "Water-Well" }, // no `to` = current page
        ]}
        />

        <section class="split-about">
        <div class="split-about__wrap">
            <div class="split-about__content">
            <p>
                Water wells are critical for agriculture, urban development, and industrial applications, playing a central role in ensuring clean water availability 
                for communities and businesses. However, drilling and maintaining water wells often involves challenges such as formation instability, fluid loss, and 
                wellbore damage that can shorten a well's lifespan. Sustainability and long-term performance are key to supporting growing demand.
            </p>
            </div>


            <figure class="split-about__media">
            <img src="/assets/images/industry/water-well.png" alt="Water Well" />
            </figure>

        </div>
        </section>

        <section class="applications">
        <div class="applications__wrap">
            <h1>Our Solutions:</h1>

            <ul class="applications__list">
            <li><strong>MD-BENT</strong>: Provides superior borehole wall sealing and smooth drilling.</li>
            <li><strong>Seal-Lube & MD-CAR</strong>: Control seepage and prevent fluid losses in weak formations.</li>
            <li><strong>Tailored Formulations</strong>: Extend well longevity and reduce maintenance costs.</li>
            </ul>

            <p>
            </p>
        </div>
        </section>        
    </div>
  )
}

export default WaterWell